import type { Int } from "@/types";

import { useGetActivity } from "@/entities/activity";
import {
  getActivityGroupedIds,
  getActivityRequestedBy,
  getActivitySubjectModel,
  useActivitySubjectType,
} from "@/modules/activity";

import { getActivityContextDate } from "./activity-context.helper";

export const useActivityContextInfos = (id: Int) => {
  const { activity, isLoading, isRefetching } = useGetActivity(id);
  const { getSubjectTypeName } = useActivitySubjectType();

  const loading = isLoading || isRefetching;

  const subject = activity?.subject;
  const subjectType = getSubjectTypeName(activity);
  const subjectModel = getActivitySubjectModel(activity);

  const causer = activity?.causer;
  const causerModel = getActivitySubjectModel(activity);

  const date = getActivityContextDate(activity);
  const requestedBy = getActivityRequestedBy(activity);
  const groupedIds = getActivityGroupedIds(activity);

  return {
    activity,
    loading,
    date,
    subject,
    subjectType,
    subjectModel,
    causer,
    causerModel,
    requestedBy,
    groupedIds,
  };
};
